import React from "react"
import tw, { styled, css } from "twin.macro"
import { toast, ToastContainer } from "react-toastify"

const Wrapper = styled("div")(() => [
  css`
    --toastify-toast-width: 100vw;
    .Toastify__toast-container {
      ${tw`left-0 top-0 p-0 transform-none border-0`}
    }
    .Toastify__toast {
      ${tw`m-0 p-0 shadow-none rounded-none cursor-default`}
    }
    .Toastify__toast-body {
      ${tw`p-0`}
      a {
        cursor: pointer;
      }
    }
  `,
])

export const Alert = () => {
  return (
    <Wrapper>
      <ToastContainer
        enableMultiContainer
        containerId={"Sticky"}
        position={toast.POSITION.TOP_CENTER}
        closeButton={false}
        closeOnClick={false}
        autoClose={false}
        draggable={false}
        style={{ position: "sticky" }}
      />
      <ToastContainer
        enableMultiContainer
        containerId={"Fixed"}
        position={toast.POSITION.TOP_CENTER}
        autoClose={2000}
        closeButton={false}
        closeOnClick={false}
        hideProgressBar={true}
        draggable={false}
      />
    </Wrapper>
  )
}

export default Alert
